import { offset as baseOffset } from '@floating-ui/dom';
import { getFloatingUIOffset } from '../utils/getFloatingUIOffset';
/**
 * Wraps floating UI offset middleware to to transform offset value
 */
export function offset(offsetValue) {
  const floatingUIOffset = getFloatingUIOffset(offsetValue);
  return baseOffset(floatingUIOffset);
}